import styled from "styled-components";
import { Frame1410 } from "./styles";

export default function MemberTypeSelector({ selected, onSelectMemberType }) {
  return (
    <Frame1410 style={{ gap: "16px", paddingBlock:"16px" }}>
      <Frame5>
        If you are willing to Sign-up as a Limited Liability Partnership, click
        on Enterprise Member
      </Frame5>
      <Frame1412>
        <Button
          onClick={() => onSelectMemberType("individual")}
          style={{
            background: selected === "individual" ? "#1E1F4B" : "#F9FAFB",
            color: selected === "individual" ? "#FFFFFF" : "#64748B",
          }}
        >
          Individual Member
        </Button>

        <Button
          onClick={() => onSelectMemberType("enterprise")}
          style={{
            background: selected === "enterprise" ? "#1E1F4B" : "#F9FAFB",
            color: selected === "enterprise" ? "#FFFFFF" : "#64748B",
          }}
        >
          Enterprise Member
        </Button>
      </Frame1412>
    </Frame1410>
  );
}

const Frame1412 = styled.div`
  border-radius: 32px;
  background: #f1f5f9;
  display: flex;
  align-items: flex-start;
  width: 100%;
`;
const Frame5 = styled.p`
  color: var(--Color-Brand-Primary, #212543);

  /* P3 */
  font-family: Montserrat;
  font-size: var(--Fonts-P3, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: 160%; /* 25.6px */
  letter-spacing: -0.16px;
`;
const Button = styled.button`
  display: flex;
  flex: 1;
  padding: var(--Padding-Normal, 16px) var(--Padding-Large, 32px);
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  border: none;
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%; /* 17.6px */
`;
